import React from 'react';
import { Box } from '@mui/material';
import VerticalLoadingScreen from './VerticalLoadingScreen';
import { LOADING_IMAGES, LOADING_MESSAGES } from './utils/trainLoading.data';

/** Train vertical loader — train search and results. */
const TrainLoader = ({ active = true, minHeight = '400px' }) => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        width: '100%',
        minHeight,
        background: 'transparent',
      }}
    >
      <VerticalLoadingScreen
        active={active}
        images={LOADING_IMAGES}
        messages={LOADING_MESSAGES}
      />
    </Box>
  );
};

export default TrainLoader;
